import React, { ReactNode } from 'react';
import { ErrorMessage } from 'ui-toolkit';

export interface IErrorBoundaryProps {
  children: ReactNode;
}

export class ErrorBoundary extends React.Component<IErrorBoundaryProps, { hasError: boolean; error?: Error }> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({ ...this.state, error });
  }

  render() {
    return (
      <>
        {this.state.hasError && <ErrorMessage error={this.state.error} />}
        {!this.state.hasError && this.props.children}
      </>
    );
  }
}
